'use strict';

/**
 * Override type values stored in the price-overrides collection.
 * Tracks how a price override was created.
 */
module.exports = {
  costPriceDelta: 'CostPriceDelta',
  transferPriceDelta: 'TransferPriceDelta',
  purchasePriceDelta: 'PurchasePriceDelta',
  intentionPrice: 'IntentionPrice',
  proposedPrice: 'ProposedPrice',
  manual: 'Manual',
  transitionPeriod: 'TransitionPeriod',
};
